// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1TuAX","legacyBtn":"MutateMid_legacyBtn__bS2Zn"};